var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealthSafetyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#112034;stroke-linecap:round;stroke-width:15.41px;}.cls-1,.cls-2,.cls-3{stroke-miterlimit:10;}.cls-2{fill:#fff;stroke:#4a5d79;stroke-width:12.26px;}.cls-3{fill:#af0e38;stroke:#af0e38;stroke-width:7.19px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.75,138.57H18.9a5.44,5.44,0,0,0-1,.09c-4.17.82-7.58,3.46-8.81,7-1.57,4.46-.17,9.13,5.53,12.58a4.12,4.12,0,0,0,2.1.55H89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.4,51.28A80.39,80.39,0,0,0,49.4,71s-15.26,16-18.6,36.61a163.11,163.11,0,0,0-1.55,18.3c-.15,4.68-.09,8.57,0,11.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82,85.07v-31c0-1.81.1-12.6,9.3-19.71,7.06-5.46,15.35-5.57,20.15-5.63C116,28.7,123.31,28.6,130,33c10,6.54,10.76,17.9,10.85,19.71V85.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.25,51.28a80.19,80.19,0,0,1,31,19.71h0A71.88,71.88,0,0,1,192,103.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M156.56,77.26,104,90.2a167.82,167.82,0,0,0-.43,24.36c1.08,19.44,2.47,40,17.23,56.33,8.63,9.55,17.52,12.9,19.8,13.7a46.61,46.61,0,0,0,15.5,2.67,48.16,48.16,0,0,0,14.64-2.67,52.23,52.23,0,0,0,21.1-13.7c14-14.69,14.66-33.59,15.5-56.33a188.74,188.74,0,0,0-.65-24.17Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 150.94,
    y: 102.69,
    width: 11.41,
    height: 53.5,
    rx: 0.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 151.03,
    y: 102.25,
    width: 11.22,
    height: 54.39,
    rx: 0.26,
    transform: "matrix(0, -1, 1, 0, 27.2, 286.09)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthSafetyIcon);
export default __webpack_public_path__ + "static/media/Health&Safety_Icon.a5ee5c44825cee1a5ba476f1c28a173a.svg";
export { ForwardRef as ReactComponent };